import { Ability, AbilityClass, AbilityBuilder } from '@casl/ability';
import { User } from '@/models/user';
import { TimeEntries } from '@/models/time-entries';
import { Project, SalesProject } from '@/models/project';
import { ADMIN_ROLE } from '@/utils/config';

type Actions = 'visit' | 'read' | 'manage';
type Subjects = 'Home' | typeof TimeEntries | TimeEntries | 'TimeEntries' | typeof Project | Project | 'Project' | typeof SalesProject | SalesProject  | 'SalesProject' | 'Costs' | 'Portfolio' | 'ProjectHierarchy' | 'Issue' | 'ProjectVersion' | 'KPI' | 'WPS' | 'TrackingProjects' | 'TrackingInitiative'

export type RedankaAbility = Ability<[Actions, Subjects]>;
export const RedankaAbility = Ability as AbilityClass<RedankaAbility>;

export function defineRulesFor(user: User | null) {
    const { can, rules } = new AbilityBuilder<RedankaAbility>();
    // FIXME we need to use a more elegant solution...
    if (user != null) {
        if (user.redanka_roles.includes(ADMIN_ROLE)) {
            //can(['visit', 'manage'], ['Home', 'Portfolio', 'ProjectHierarchy', 'Project', 'Issue', 'ProjectVersion', 'TimeEntries', 'KPI']);
            can('visit', ['Home', 'Portfolio', 'ProjectHierarchy', 'Project',
            // 'SalesProject',
            'Costs', 'Issue', 'ProjectVersion', 'TimeEntries', 'KPI', 'TrackingProjects', 'TrackingInitiative']);
            can('read', 'Project');
            can('read', 'TimeEntries');
            can('read', 'WPS');  // FIXME this shoud be project specific by role
            can('read', 'Costs');  // FIXME this shoud be project specific by role
            //can('read', TimeEntries, { user_address: user.email });
        } else if (user.redanka_roles.includes("allowed_user")) { // TODO make it configurable
//            if (user.time_entry_role == 'employee') {
                can('visit', 'Home');
                can('visit', 'Project');
                can('visit', 'TimeEntries');
                can('read', 'TimeEntries', { user_address: user.email });
                user.memberships.forEach(membership => {
                    if (membership.roles.length > 0) {
                        can('read', 'Project', { id: String(membership.project?.id) });
                    }
                });
//            }
            //can('visit', ['Project', 'Issue', 'ProjectVersion']);
        }

        if (user.redanka_roles.includes("hrm")) {  // TODO make it configurable
            can('read', 'TimeEntries');
        }
        // TODO
    }
    

    // TODO

    console.log("Abilities new rules:", JSON.stringify(rules))
    return rules;
}

export function buildAbilityFor(user: User | null) {
    return new RedankaAbility(defineRulesFor(user));
}